import teasersExperienceQuery from './teasers-experience-query';
import teasersQuery from './teasers-query';

export default `
	uri
	slug
	type {
		handle
	}
	title
	caption
	cursorText
	experienceType
	eventNumber
	showInCollections
	meta {
		content
	}
	enabled
	${teasersExperienceQuery}
	${teasersQuery}
`;
